import { render, staticRenderFns } from "./menuSelection.vue?vue&type=template&id=38820593&scoped=true"
import script from "./menuSelection.vue?vue&type=script&lang=js"
export * from "./menuSelection.vue?vue&type=script&lang=js"
import style0 from "./menuSelection.vue?vue&type=style&index=0&id=38820593&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38820593",
  null
  
)

export default component.exports